
/**
 * 환불 유형
 */
export type RefundRequestResponseRefundType = typeof RefundRequestResponseRefundType[keyof typeof RefundRequestResponseRefundType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefundRequestResponseRefundType = {
  FULL: 'FULL',
  PARTIAL: 'PARTIAL',
  AI_USAGE_BASED: 'AI_USAGE_BASED',
} as const;
